import { Checkbox, Switch } from '@progress/kendo-react-inputs';
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from '../../../../messages/en-US';
import ReportFilter from '../ReportFilter';

export interface ComplianceFilters {
  rightGrease: boolean;
  rightAmount: boolean;
  rightTime: boolean;
}

export interface WorkOrdersFiltersProps {
  allLocAssetTree: any[];
  selectedLocAssetTree: any[];
  onSelectedLocAssetTreeChange: (data: any[]) => void;
  locAssetTreeDisabled: boolean;
  locAssetTreeTagCounts?: { selected: number; total: number };
  allSchedules: any[];
  selectedSchedules: any[];
  onSelectedSchedulesChange: (data: any[]) => void;
  schedulesDisabled: boolean;
  scheduleTagCounts?: { selected: number; total: number };
  includeUntrackedGreasing: boolean;
  onIncludeUntrackedGreasingChange: (value: boolean) => void;
  compliance: ComplianceFilters;
  onComplianceChange: (key: keyof ComplianceFilters, value: boolean) => void;
  filterResetKey?: number;
}

const sectionLabel = 'text-[11px] uppercase tracking-wide text-slate-400 font-medium mb-1';

export default function WorkOrdersFilters({
  allLocAssetTree,
  selectedLocAssetTree,
  onSelectedLocAssetTreeChange,
  locAssetTreeDisabled,
  locAssetTreeTagCounts,
  allSchedules,
  selectedSchedules,
  onSelectedSchedulesChange,
  schedulesDisabled,
  scheduleTagCounts,
  includeUntrackedGreasing,
  onIncludeUntrackedGreasingChange,
  compliance,
  onComplianceChange,
  filterResetKey,
}: WorkOrdersFiltersProps) {
  const localizationService = useLocalization();

  const locationsL = localizationService.toLanguageString('custom.locations', enMessages.custom.locations);
  const assetsL = localizationService.toLanguageString('custom.assets', enMessages.custom.assets);
  const schedulesL = localizationService.toLanguageString('custom.schedules', enMessages.custom.schedules);

  return (
    <div className="flex flex-col gap-5">
      {allLocAssetTree[0]?.items?.length > 0 && (
        <div>
          <div className={sectionLabel}>{`${locationsL} / ${assetsL}`}</div>
          <ReportFilter
            data={selectedLocAssetTree}
            disabled={locAssetTreeDisabled}
            onChange={onSelectedLocAssetTreeChange}
            tag={assetsL}
            initialData={allLocAssetTree}
            textField="name"
            popupWidth={450}
            popupHeight={500}
            tagCounts={locAssetTreeTagCounts}
            resetKey={filterResetKey}
          />
        </div>
      )}

      {allSchedules.length > 0 && (
        <div>
          <div className={sectionLabel}>{schedulesL}</div>
          <ReportFilter
            data={selectedSchedules}
            disabled={schedulesDisabled}
            onChange={onSelectedSchedulesChange}
            tag={schedulesL}
            initialData={allSchedules}
            textField="name"
            popupWidth={450}
            tagCounts={scheduleTagCounts}
            resetKey={filterResetKey}
          />
        </div>
      )}

      <div className="flex items-center gap-2">
        <Switch
          checked={includeUntrackedGreasing}
          onChange={(e) => onIncludeUntrackedGreasingChange(e.value)}
          size="small"
        />
        <span className="text-sm text-slate-600">
          {localizationService.toLanguageString('custom.includeUntrackedGreasing', enMessages.custom.includeUntrackedGreasing)}
        </span>
      </div>

      <div className="border-t border-slate-200" />

      <div>
        <div className={sectionLabel}>
          {localizationService.toLanguageString('custom.compliance', enMessages.custom.compliance)}
        </div>
        <div className="flex flex-col gap-2">
          <Checkbox
            label={localizationService.toLanguageString('custom.rightGrease', enMessages.custom.rightGrease)}
            value={true}
            disabled={true}
          />
          <Checkbox
            label={localizationService.toLanguageString('custom.rightAmount', enMessages.custom.rightAmount)}
            value={compliance.rightAmount}
            onChange={(e) => onComplianceChange('rightAmount', e.value)}
          />
          <Checkbox
            label={localizationService.toLanguageString('custom.rightTime', enMessages.custom.rightTime)}
            value={true}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
}
